import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useStep(stepId) {
  const [step, setStep] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.steps.show(stepId))
      .then((response) => {
        setStep(response.data.data);
      });
  }, [stepId]);

  return step;
}
